import React, {Component} from 'react'
import * as func from "../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../wpconfig"

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
	faAngleRight,
	faAngleDown,
	faEdit,
	faSave,
	faTimes,
	faCheckSquare,
	faTrashAlt,
	faGripVertical
} from '@fortawesome/free-solid-svg-icons'

class Item extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record: func.deepClone(this.props.record),
			// isOpenChild : false,
			// // name : '아이디',
			// field : 'category',
			// id : 'category_id',
			name: 'name_value',
			pkKey: 'ID',
		}
	}

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, true);
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.props.record[this.props.pkKey]) {
				func.updateData("admin/scholar/" + func.getParams("record_id") + "/names/update", this.props.record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({record: func.deepClone(this.props.record)})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = this.props.record;
				if (this.name_type.value == "") {
					this.name_type.focus();
					this.props.showMessage('유형을 선택해주세요.');
				} else {
					delete record.is_edit;
					func.updateData("admin/scholar/" + func.getParams("record_id") + "/names/insert", this.props.record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							this.props.record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, this.props.record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.arrIndex)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (event) => {
		event.preventDefault()
		if (this.props.record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.setState({'isEdit': EDIT_MODE.SHOW});
				this.props.onUpdate(this.props.arrIndex, func.deepClone(this.state.record), true);
			} else {
				if (confirm(this.props.record[this.state.name] + '을(를) ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("admin/scholar/" + func.getParams("record_id") + "/names/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.arrIndex)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.arrIndex, func.deepClone(this.state.record), true);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	};

	render() {
		const {record, name_type, name_type_Name} = this.props
		const {onEditSave, onCloseDelete} = this;

		if (name_type_Name == undefined)
			return false

		return (
			<>
				{
					this.state.isEdit === EDIT_MODE.SHOW ? (
						<>
							<tr>
								<td>
									<label className="mt-2">{name_type_Name[record.name_type]}</label>
								</td>
								<td>
									<label className="mt-2">{record.name_value}</label>
								</td>
								<td>
									<div className="btn-group">
										<button className="btn btn-outline-success btn-sm insert"
										        onClick={this.onEditSave}>{record[this.props.pkKey] ? '수정' : '저장'}</button>
										<button className="btn btn-outline-danger btn-sm cancel" onClick={this.onCloseDelete}>삭제</button>
									</div>
								</td>
							</tr>
						</>
					) : (
						<>
							<tr>
								<td>
									<select className="form-control form-control-sm"
									        defaultValue={record.name_type}
									        ref={(ref) => this.name_type = ref}
									        name="name_type"
									        onChange={this.change}>
										<option value="">선택해주세요.</option>
										{name_type.map((type, i) => {
											return (<option key={type.code_id} value={type.code_id}
											                checked={record.name_type == type.code_id ? true : false}>{type.code_name}</option>)
										})}
									</select>
								</td>
								<td>
									<input
										type="text"
										name="name_value"
										value={record.name_value}
										onChange={this.change}
										className="form-control-sm large-text"
									/>
								</td>
								<td>
									<div className="btn-group">
										<button className="btn btn-outline-primary btn-sm insert" onClick={this.onEditSave}>저장</button>
										<button className="btn btn-outline-secondary btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
									</div>
								</td>
							</tr>
						</>
					)
				}
			</>
		)
	}
}

export default Item;
